$(document).ready(function() {
    /* Select active menu */
    var adress = window.location.pathname;
    first =adress.split('/');
    first = first[1];
    if(adress == '/') {
        $( "#menu > nav > div > ul > li " ).eq(0).addClass('active');
    } else {
        $( "#menu > nav > div > ul > li" ).each(function( index ) {
            if($(this).html().indexOf(adress)>0) {
                $( "#menu > nav > div > ul .active" ).removeClass('active');
                $(this).addClass('active');
                first = null;
                return;
            } else if($(this).html().indexOf(first)>0) {
                $(this).addClass('active');
            } 
        });
    } 
    if(adress == '/') {
        $( "#mobileMenu > ul > li " ).eq(0).addClass('active');
    } else {
        $( "#mobileMenu > ul > li" ).each(function( index ) {
            if($(this).html().indexOf(adress)>0) {
                $( "#mobileMenu > ul  .active" ).removeClass('active');
                $(this).addClass('active');
                first = null;
                return;
            } else if($(this).html().indexOf(first)>0) {
                $(this).addClass('active');
            } 
        });
    } 
    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
  });
  $('document').ready(function(){

        $('#expand1').click(function(){
        $('#expand-content1').toggleClass('__form--label-visible');
        $(this).toggle();
        });

        $('#expand2').click(function(){
        $('#expand-content2').toggleClass('contact-widget__form--label-visible');
        $(this).toggle();
        });

    });

    
    $('.owl-carousel').owlCarousel({
        rtl:true,
        loop:true,
        autoWidth:false,
        nav:false,
       
        responsive:{
            0:{
                items:1,
                stagePadding: 40,
                
            },
            767:{
                stagePadding:0,
                items:3
            }
        }
    })
    if($( window ).width() <= 767)
    {
        $('.owl-carousel').trigger('to.owl.carousel',1) 
    }
    $( ".cross" ).hide();
    $( ".menuHamburger" ).hide();
    $( ".hamburger" ).click(function() {
        $( ".menuHamburger" ).slideToggle( "slow", function() {
            $( ".hamburger" ).hide();
            $( ".cross" ).show();
        });
    });

    $( ".cross" ).click(function() {
        $( ".menuHamburger" ).slideToggle( "slow", function() {
            $( ".cross" ).hide();
            $( ".hamburger" ).show();
        });
    });

    
});

//# sourceMappingURL=default.js.map

// allow show multi level menu
        $('.dropdown-submenu a.test').click(function(event) {
            event.stopImmediatePropagation();
        })
        $('.dropdown-submenu .dropdown-submenu a.dropdown-toggle').click(function(event) {
          event.preventDefault();
            event.stopImmediatePropagation();
            $(this).toggleClass('hover');
        })